import styled from 'styled-components';

import { opacityModifier } from '@/utils';

export const Background = styled.div`
  align-items: center;
  backdrop-filter: blur(8px);
  background-color: ${({ theme }) => opacityModifier(theme.color.ui8, 0.7)};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const Container = styled.div<{
  width?: string | number;
}>`
  align-items: stretch;
  display: flex;
  gap: 20px;
  flex-direction: column;
  width: ${({ width }) => width ?? '420px'};
`;

export const Label = styled.div`
  flex: 1;
  color: ${({ theme }) => theme.color.ui2};
  ${({ theme }) => theme.font.t1};
`;

export const LabelWrapper = styled.div`
  display: flex;
  height: auto;
  min-height: 24px;
`;

export const ProgressNumber = styled.div`
  color: ${({ theme }) => theme.color.s1};
  height: 16px;
  text-align: end;
  ${({ theme }) => theme.font.t4};
`;

export const ProgressWrapper = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
